import apiCall from './apiRequest';
import endPoints from './endpoints';

export function currentCreditApi({ companyUUID, token }) {
    return apiCall({
        method: 'get',
        endpoint: endPoints.currentCredit,
        authToken: token,
        query: `companyUUID=${companyUUID}`,
    });
}
